// import { createSelector } from 'reselect';
export const getIsDownloading = state => state.getIn(['appointmentUserFiles', 'isDownloading']);
export const getIsPosting = state => state.getIn(['appointmentUserFiles', 'isPosting']);
export const getIsPutting = state => state.getIn(['appointmentUserFiles', 'isPutting']);
export const getIsDeleting = state => state.getIn(['appointmentUserFiles', 'isDeleting']);
export const getIsBackuping = state => state.getIn(['appointmentUserFiles', 'isBackuping']);
export const getErrMsg = state => state.getIn(['appointmentUserFiles', 'errMsg']);
export const getIsExceededQuota = state => state.getIn(['attachment', 'isExceededQuota']);